import { useTranslatedLinksFromBlok, useTranslation } from '../../../lib/context/i18n'
import { Button, Icon } from '../../../components/UI'
import * as React from 'react'
import { BlogProductTeaser } from '../../../templates/BlogPostTemplate/types'
import { Tooltip } from '../../../components/UI/Tooltip'
import {
  StyledContentContainer,
  StyledMediaElement,
  StyledNameContainer,
  StyledOSContainer,
  StyledParagraph,
  StyledProductName,
  StyledProductTeaserItem,
} from './styled'
import CustomLink from '../../../components/CustomLink'

export const ProductTeaserItem = ({ product }: { product: BlogProductTeaser }) => {
  const translations = useTranslation()
  const translatedLink = useTranslatedLinksFromBlok()
  // TODO: add types to used product
  const { content, full_slug, translated_slugs } = product

  const productLink = translatedLink(full_slug, translated_slugs)
  const productVariants = content?.productVariant || []

  return (
    <StyledProductTeaserItem as={CustomLink} to={productLink}>
      <StyledMediaElement mediaSrc={content?.productIcon.filename} title={content?.productIcon.title} />
      <StyledContentContainer>
        <StyledNameContainer>
          <StyledParagraph className={`theme-${content?.colorTheme}`}>{content?.productGroup}</StyledParagraph>
          <StyledProductName>{content?.productName}</StyledProductName>
        </StyledNameContainer>
        <StyledOSContainer>
          {productVariants.map((variant, index) => (
            <Tooltip
              title={translations('general_ProductVariants')}
              text={variant?.content?.name}
              noWrap
              key={`variant-${content?.productName}-${index}`}
            >
              <Icon name={variant?.content?.icon} key={index} iconSize="1rem" />
            </Tooltip>
          ))}
        </StyledOSContainer>
      </StyledContentContainer>

      <Button $ignoreTheme={true} $size="small" iconRight="arrow-right" $variant={'tertiary'} />
    </StyledProductTeaserItem>
  )
}
